export const SIZE_PER_PAGE_LIST = [{
  text: '100',
  value: 100
}, {
  text: '10',
  value: 10
}, {
  text: '20',
  value: 20
}, {
  text: '30',
  value: 30
}];
export const defaultPaginationOptions = {
  paginationSize: 10,
  pageStartIndex: 1,
  withFirstAndLast: false,
  showTotal: true,
  sizePerPageList: SIZE_PER_PAGE_LIST
};
export const noPaginationOptions = hidePagination => {
  if (hidePagination) {
    return {
      paginationSize: 10000,
      pageStartIndex: 1,
      hidePageListOnlyOnePage: true,
      withFirstAndLast: false,
      showTotal: false,
      sizePerPageList: [{
        text: '10000',
        value: 10000
      }]
    };
  }

  return {};
};